export const FETCH_ALLTEACHERS_REQUEST = 'FETCH_ALLTEACHERS_REQUEST'
export const FETCH_ALLTEACHERS_SUCCESS = 'FETCH_ALLTEACHERS_SUCCESS'
export const FETCH_ALLTEACHERS_FALIURE = 'FETCH_ALLTEACHERS_FALIURE'
